import React from "react"
import { Typography } from "@mui/material"


export default function idColumn() {
	return {
		name: 'id_batch',
		label: 'Batch ID',
		options: {
			filterType: "textField",
			// the ID is long and only read whole on hover: its room goes to Status, which a 13" screen cut
			customBodyRowRenderLite: value => <Typography title={value}
				sx={{ textAlign: "center", maxWidth: 150, mx: "auto", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{value}</Typography>
		}
	}
}